import React from 'react'
import { CenteredPageInner, PageContainer } from '../../components/Layout/PageContainer'
import { useVerificationContext, VerificationStatus } from '../verification/VerificationContext'
import { Feature, useFeatureFlag } from '../../context/useFeatureFlag'
import { PageLoading } from '../../components/PageLoading'
import { FadePresence } from '../../components/FadePresence'

import { useSpritzCardQuery } from '../../graphql/generated/graphql'
import { SpritzCardSetup, SpritzCardVerify } from './SpritzCardSetup'
import { SpritzCardInfo } from './SpritzCardInfo'
import styled from 'styled-components'
import { SpritzCardInfoDialogProvider } from './SpritzCardInfoDialog'
import { breakpoints } from '@spritz-finance/ui'

const SpritzCardPageInner = styled(CenteredPageInner)`
    max-width: 698px;
    width: 698px;
    box-sizing: border-box;

    ${breakpoints.xsmall} {
        width: 100%;
        max-width: none;
    }
`

export const SpritzCardPage = () => {
    const { verificationStatus, loading: verifiedLoading } = useVerificationContext()
    const { data, loading: cardLoading } = useSpritzCardQuery()
    const enabled = useFeatureFlag(Feature.SpritzCard)

    const loading = verifiedLoading || cardLoading
    const hasCard = !!data?.virtualCard

    if (!enabled) return null

    if (loading) return <PageLoading />

    let renderKey: 'verify' | 'setupcard' | 'card'
    if (verificationStatus !== VerificationStatus.Verified) {
        renderKey = 'verify'
    } else if (!hasCard) {
        renderKey = 'setupcard'
    } else {
        renderKey = 'card'
    }

    return (
        <PageContainer>
            <SpritzCardPageInner>
                <SpritzCardInfoDialogProvider>
                    <FadePresence renderKey={renderKey}>
                        {renderKey === 'verify' && <SpritzCardVerify />}
                        {renderKey === 'setupcard' && <SpritzCardSetup />}
                        {renderKey === 'card' && <SpritzCardInfo />}
                    </FadePresence>
                </SpritzCardInfoDialogProvider>
            </SpritzCardPageInner>
        </PageContainer>
    )
}
